/* src/routes/index.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	check_outros,
	claim_component,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { preloader } from "./preload.js";
import { Popup } from "../../_modules/popup/index.js";
import { News } from "../../_modules/news/index.js";
import { Car } from "../../_modules/car/index.js";
import Dialog from "../../_components/popup/Dialog.js";
import Page from "../../_components/slot/Page.js";
import Wrap from "../../_components/slot/Wrap.js";
import Section from "../../_components/slot/Section.js";
import List from "../../_components/list/List.js";
import Item from "../../_components/list/Item.js";
import KeyVisual from "../../_components/block/KeyVisual.js";
import NewsLink from "../../_components/news/Link.js";
import CarLink from "../../_components/car/LargeLink.js";
import CTA from "../../_components/block/CTA.js";
import CTContact from "../../_components/block/CTContact.js";
import Banner from "../../_components/button/Banner.js";
import Instagram from "../../_components/block/Instagram.js";
import Head from "../../_components/meta/Head.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[3] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[3] = list[i];
	return child_ctx;
}

// (27:259) {#if popups.length > 0}
function create_if_block(ctx) {
	let dialog;
	let current;
	dialog = new Dialog({ props: { popup: /*popups*/ ctx[0][0] } });

	return {
		c() {
			create_component(dialog.$$.fragment);
		},
		l(nodes) {
			claim_component(dialog.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(dialog, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const dialog_changes = {};
			if (dirty & /*popups*/ 1) dialog_changes.popup = /*popups*/ ctx[0][0];
			dialog.$set(dialog_changes);
		},
		i(local) {
			if (current) return;
			transition_in(dialog.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(dialog.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(dialog, detaching);
		}
	};
}

// (27:485) <Item columns="4">
function create_default_slot_15(ctx) {
	let newslink;
	let current;

	newslink = new NewsLink({
			props: { newsItem: /*item*/ ctx[3], reverse: true }
		});

	return {
		c() {
			create_component(newslink.$$.fragment);
		},
		l(nodes) {
			claim_component(newslink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(newslink, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const newslink_changes = {};
			if (dirty & /*news*/ 2) newslink_changes.newsItem = /*item*/ ctx[3];
			newslink.$set(newslink_changes);
		},
		i(local) {
			if (current) return;
			transition_in(newslink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(newslink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(newslink, detaching);
		}
	};
}

// (27:465) {#each news as item}
function create_each_block_1(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				columns: "4",
				$$slots: { default: [create_default_slot_15] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope, news*/ 258) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (27:459) <List>
function create_default_slot_14(ctx) {
	let each_1_anchor;
	let current;
	let each_value_1 = /*news*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*news*/ 2) {
				each_value_1 = /*news*/ ctx[1];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (27:453) <Wrap>
function create_default_slot_13(ctx) {
	let list;
	let current;

	list = new List({
			props: {
				$$slots: { default: [create_default_slot_14] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(list.$$.fragment);
		},
		l(nodes) {
			claim_component(list.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(list, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const list_changes = {};

			if (dirty & /*$$scope, news*/ 258) {
				list_changes.$$scope = { dirty, ctx };
			}

			list.$set(list_changes);
		},
		i(local) {
			if (current) return;
			transition_in(list.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(list.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(list, detaching);
		}
	};
}

// (27:353) <Section name="お知らせ" en="NEWS" more="{['/news', 'すべてのお知らせを見る']}" background="/images/back_news.jpg">
function create_default_slot_12(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_13] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, news*/ 258) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (27:721) <Item columns="2">
function create_default_slot_11(ctx) {
	let carlink;
	let current;
	carlink = new CarLink({ props: { car: /*item*/ ctx[3] } });

	return {
		c() {
			create_component(carlink.$$.fragment);
		},
		l(nodes) {
			claim_component(carlink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(carlink, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const carlink_changes = {};
			if (dirty & /*cars*/ 4) carlink_changes.car = /*item*/ ctx[3];
			carlink.$set(carlink_changes);
		},
		i(local) {
			if (current) return;
			transition_in(carlink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(carlink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(carlink, detaching);
		}
	};
}

// (27:701) {#each cars as item}
function create_each_block(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				columns: "2",
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope, cars*/ 260) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (27:695) <List>
function create_default_slot_10(ctx) {
	let each_1_anchor;
	let current;
	let each_value = /*cars*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*cars*/ 4) {
				each_value = /*cars*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (27:689) <Wrap>
function create_default_slot_9(ctx) {
	let list;
	let current;

	list = new List({
			props: {
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(list.$$.fragment);
		},
		l(nodes) {
			claim_component(list.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(list, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const list_changes = {};

			if (dirty & /*$$scope, cars*/ 260) {
				list_changes.$$scope = { dirty, ctx };
			}

			list.$set(list_changes);
		},
		i(local) {
			if (current) return;
			transition_in(list.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(list.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(list, detaching);
		}
	};
}

// (27:588) <Section name="車両一覧" en="STOCK" more="{['/stock', 'すべての車両を見る']}" background="/images/back_stock.jpg">
function create_default_slot_8(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, cars*/ 260) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (27:832) <Wrap>
function create_default_slot_7(ctx) {
	let banner;
	let current;

	banner = new Banner({
			props: {
				name: "カーセンサー",
				href: "https://www.carsensor.net/shop/gunma/312495001/#contents",
				image: "/images/banner_carsensor.png",
				external: true
			}
		});

	return {
		c() {
			create_component(banner.$$.fragment);
		},
		l(nodes) {
			claim_component(banner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(banner, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(banner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(banner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(banner, detaching);
		}
	};
}

// (27:809) <Section color="black">
function create_default_slot_6(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 256) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (27:996) <Section background="/images/back_online.jpg" kind="gapless">
function create_default_slot_5(ctx) {
	let cta;
	let current;

	cta = new CTA({
			props: {
				name: "オンライン接客<br>実施中",
				overview: "ご来店が難しい方や不安な方のために、ビデオ通話によるオンライン接客を行っております。",
				action: "/online-service",
				color: "blue",
				position: "left"
			}
		});

	return {
		c() {
			create_component(cta.$$.fragment);
		},
		l(nodes) {
			claim_component(cta.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(cta, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(cta.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(cta.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(cta, detaching);
		}
	};
}

// (27:1214) <Section background="/images/back_contact.jpg" kind="gapless">
function create_default_slot_4(ctx) {
	let ctcontact;
	let current;

	ctcontact = new CTContact({
			props: { color: "red", position: "right" }
		});

	return {
		c() {
			create_component(ctcontact.$$.fragment);
		},
		l(nodes) {
			claim_component(ctcontact.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(ctcontact, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(ctcontact.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(ctcontact.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(ctcontact, detaching);
		}
	};
}

// (27:1361) <Wrap>
function create_default_slot_3(ctx) {
	let banner;
	let current;

	banner = new Banner({
			props: {
				name: "カーセンサー",
				href: "https://shop.lalbero.co.jp/",
				image: "/images/banner_onlineshop.png",
				external: true
			}
		});

	return {
		c() {
			create_component(banner.$$.fragment);
		},
		l(nodes) {
			claim_component(banner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(banner, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(banner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(banner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(banner, detaching);
		}
	};
}

// (27:1338) <Section color="black">
function create_default_slot_2(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 256) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (27:1497) <Section name="インスタグラム" en="INSTAGRAM" color="black">
function create_default_slot_1(ctx) {
	let wrap;
	let current;
	wrap = new Wrap({});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (27:324) <Page>
function create_default_slot(ctx) {
	let keyvisual;
	let section0;
	let section1;
	let section2;
	let section3;
	let section4;
	let section5;
	let section6;
	let current;
	keyvisual = new KeyVisual({});

	section0 = new Section({
			props: {
				name: "お知らせ",
				en: "NEWS",
				more: ["/news", "すべてのお知らせを見る"],
				background: "/images/back_news.jpg",
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				name: "車両一覧",
				en: "STOCK",
				more: ["/stock", "すべての車両を見る"],
				background: "/images/back_stock.jpg",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				color: "black",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				background: "/images/back_online.jpg",
				kind: "gapless",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	section4 = new Section({
			props: {
				background: "/images/back_contact.jpg",
				kind: "gapless",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	section5 = new Section({
			props: {
				color: "black",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	section6 = new Section({
			props: {
				name: "インスタグラム",
				en: "INSTAGRAM",
				color: "black",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(keyvisual.$$.fragment);
			create_component(section0.$$.fragment);
			create_component(section1.$$.fragment);
			create_component(section2.$$.fragment);
			create_component(section3.$$.fragment);
			create_component(section4.$$.fragment);
			create_component(section5.$$.fragment);
			create_component(section6.$$.fragment);
		},
		l(nodes) {
			claim_component(keyvisual.$$.fragment, nodes);
			claim_component(section0.$$.fragment, nodes);
			claim_component(section1.$$.fragment, nodes);
			claim_component(section2.$$.fragment, nodes);
			claim_component(section3.$$.fragment, nodes);
			claim_component(section4.$$.fragment, nodes);
			claim_component(section5.$$.fragment, nodes);
			claim_component(section6.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(keyvisual, target, anchor);
			mount_component(section0, target, anchor);
			mount_component(section1, target, anchor);
			mount_component(section2, target, anchor);
			mount_component(section3, target, anchor);
			mount_component(section4, target, anchor);
			mount_component(section5, target, anchor);
			mount_component(section6, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const section0_changes = {};

			if (dirty & /*$$scope, news*/ 258) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope, cars*/ 260) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope*/ 256) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const section3_changes = {};

			if (dirty & /*$$scope*/ 256) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
			const section4_changes = {};

			if (dirty & /*$$scope*/ 256) {
				section4_changes.$$scope = { dirty, ctx };
			}

			section4.$set(section4_changes);
			const section5_changes = {};

			if (dirty & /*$$scope*/ 256) {
				section5_changes.$$scope = { dirty, ctx };
			}

			section5.$set(section5_changes);
			const section6_changes = {};

			if (dirty & /*$$scope*/ 256) {
				section6_changes.$$scope = { dirty, ctx };
			}

			section6.$set(section6_changes);
		},
		i(local) {
			if (current) return;
			transition_in(keyvisual.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			transition_in(section4.$$.fragment, local);
			transition_in(section5.$$.fragment, local);
			transition_in(section6.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(keyvisual.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			transition_out(section4.$$.fragment, local);
			transition_out(section5.$$.fragment, local);
			transition_out(section6.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(keyvisual, detaching);
			destroy_component(section0, detaching);
			destroy_component(section1, detaching);
			destroy_component(section2, detaching);
			destroy_component(section3, detaching);
			destroy_component(section4, detaching);
			destroy_component(section5, detaching);
			destroy_component(section6, detaching);
		}
	};
}

function create_fragment(ctx) {
	let head;
	let if_block_anchor;
	let page;
	let current;

	head = new Head({
			props: {
				title: "株式会社アルベロ | Auto gallery L'albero | 群馬県の輸入車販売店",
				path: "",
				description: "株式会社アルベロは、群馬県前橋市にある自動車販売店です。輸入車を中心に、高品質な車両を新車、中古車問わずどんな車両でも常時取り揃えております。自社工場も完備しているので、購入後のメンテナンスもお任せください。ランボルギーニからフェラーリ等スーパーカーの残クレも取り扱っています。",
				image: "/images/keyvisual.jpg"
			}
		});

	let if_block = /*popups*/ ctx[0].length > 0 && create_if_block(ctx);

	page = new Page({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(head.$$.fragment);
			if (if_block) if_block.c();
			if_block_anchor = empty();
			create_component(page.$$.fragment);
		},
		l(nodes) {
			claim_component(head.$$.fragment, nodes);
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
			claim_component(page.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(head, target, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			mount_component(page, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*popups*/ ctx[0].length > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*popups*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			const page_changes = {};

			if (dirty & /*$$scope, cars, news*/ 262) {
				page_changes.$$scope = { dirty, ctx };
			}

			page.$set(page_changes);
		},
		i(local) {
			if (current) return;
			transition_in(head.$$.fragment, local);
			transition_in(if_block);
			transition_in(page.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(head.$$.fragment, local);
			transition_out(if_block);
			transition_out(page.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(head, detaching);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
			destroy_component(page, detaching);
		}
	};
}

const preload = preloader;

function instance($$self, $$props, $$invalidate) {
	let { popups = [] } = $$props;
	let { news = [] } = $$props;
	let { cars = [] } = $$props;

	$$self.$$set = $$props => {
		if ("popups" in $$props) $$invalidate(0, popups = $$props.popups);
		if ("news" in $$props) $$invalidate(1, news = $$props.news);
		if ("cars" in $$props) $$invalidate(2, cars = $$props.cars);
	};

	return [popups, news, cars];
}

class Routes extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { popups: 0, news: 1, cars: 2 });
	}
}

export default Routes;
export { preload };
//# sourceMappingURL=index.js.map
